import { Component } from 'react';
import styled from 'styled-components';
import { DefaultTheme, SC_BLACK } from '../themes/DefaultTheme';

function getVariationColor(props) {
  switch (props.variation) {
    case 'normal':
    default:
      return DefaultTheme.messages.normal.color;
    case 'secondary':
      return DefaultTheme.messages.secondary.color;
    case 'info':
      return DefaultTheme.messages.info.color;
    case 'warning':
      return DefaultTheme.messages.warning.color;
    case 'error':
      return DefaultTheme.messages.error.color;
    case 'success':
      return DefaultTheme.messages.success.color;
  }
}

const MessageElement = styled.div`
  font-weight: 300;
  text-align: center;
  font-size: 14px;
  color: ${SC_BLACK};
  background-color: ${(props: any) => getVariationColor(props)};
  border-radius: 5px;
  padding: 20px;
  cursor: default;
` as any;

const MessageContent = styled.div`
  margin-right: 10px;
` as any;

export type MessageVariation = 'normal' | 'secondary' | 'info' | 'warning' | 'error' | 'success';

export interface IProps {
  variation?: MessageVariation;
}

export class Message extends Component<IProps> {
  public render() {
    return (
      <MessageElement {...this.props} data-testid="MessageElement">
        <MessageContent>{this.props.children}</MessageContent>
      </MessageElement>
    );
  }
}
